function BikeStructureRequestTransformer(
	jsonMapper,
	util,
	quoteOptions,
	storage
) {
	var structureQuoteMapping = {
		periodStartDate: '=_input.bikeForm.getStarted.policyStartDate',
		motorcycles: [],
		'motorcycles.0': {},
		'motorcycles.0.sumInsuredType':
			'=_input.bikeForm.insuredExcessValue.comprehensivePref',
		'motorcycles.0.sumInsuredAmount': '=_regoSearch.goodRetailPrice',
		'motorcycles.0.otherRidersCount':
			'=_input.bikeForm.rider.numberOfOtherRiders',
		'motorcycles.0.motorcycleInfo':
			'=_input.bikeForm.aboutYourBike.yearMakeModelResponse',
		'motorcycles.0.accountLocation': '=_addressSearch',
		'motorcycles.0.purchasePrice':
			'=_input.bikeForm.aboutYourBike.bikeCost',
		'motorcycles.0.purchaseDate':
			'=_input.bikeForm.aboutYourBike.purchaseDate',
		'motorcycles.0.youngestRiderDateOfBirth':
			'=_input.bikeForm.rider.youngestRiderDob',
		'motorcycles.0.isBikeModified':
			'=_input.bikeForm.modificationsAccessories.modifications',
		'motorcycles.0.isAccessoriesAdded':
			'=_input.bikeForm.modificationsAccessories.accessories',

		'motorcycles.0.riders': [],
		'motorcycles.0.riders.0.licensedToRide':
			'_input.bikeForm.riders[0].licensedToRide',

		policyHolders: [],
		'policyHolders.*.contact.prefix':
			'=_input.bikeForm.rider.riders[0].person.title',
		'policyHolders.0': {},
		'policyHolders.0.contact.gender': '=_input.bikeForm.rider.gender',
		'policyHolders.0.contact.dateOfBirth':
			'=_input.bikeForm.rider.dateOfBirth',
		'policyHolders.0.contact.emailAddress1':
			'=_input.bikeForm.yourEmail.email',
		'policyHolders.0.contact.primaryAddress': '=_addressSearch',
		'policyHolders.0.contact.contactType':
			'=_input.bikeForm.getStarted.personOrCompany',

		policyAddress: '=_addressSearch',
		'policyAddress.addressType': 'postal',

		email: '=_input.email',
		campaignCode: '=_input.bikeForm.promotionalCode.promotionalCode',
		mainContactAddress: '=_addressSearch-main-contact',
		postalAddress: '=_addressSearch-postal-address'
	};

	// region Step 1
	function updateIsMotorRegistered(transformedRequest) {
		try {
			var bike = transformedRequest.motorcycles[0];

			if (bike.coverType === 'fireandtheft') {
				bike.isMotorRegistered = false;
			}
			if (bike.isMotorRegistered === undefined) {
				bike.isMotorRegistered = true;
			}
		} catch (ex) {
			console.log(ex);
		}

		return transformedRequest;
	}

	function updatePolicyHolderPrimaryAddress(transformedRequest) {
		try {
			var policyHolder = transformedRequest.policyHolders[0];

			if (!!policyHolder.contact.primaryAddress) {
				policyHolder.contact.primaryAddress.addressType = 'residential';
			}

			transformedRequest.policyHolders[0] = policyHolder;
		}
		catch (ex) {
			console.log(ex);
		}
		return transformedRequest;
	}

	function findYoungestRider(riders) {
		var youngest = null;
		riders.forEach(function(rider) {
			if (!youngest) {
				youngest = rider;
			} else if (isYounger(rider, youngest)) {
				youngest = rider;
			}
		});

		function isYounger(rider, otherRider) {
			return (
				moment(rider.person.dateOfBirth, 'DD/MM/YYYY') >
				moment(otherRider.person.dateOfBirth, 'DD/MM/YYYY')
			);
		}

		return youngest;
	}

	function updateModifications(transformedRequest, userInput) {
		var bike = transformedRequest.motorcycles[0];

		if (!!userInput.bikeForm && !!userInput.bikeForm.modificationsAccessories) {
			if (!!userInput.bikeForm.modificationsAccessories.modifications) {
				var modifications =
					userInput.bikeForm.modificationsAccessories
						.modificationsTable;

				bike.qpyCycleModifications = modifications.map(function(
					mod,
					i
				) {
					return {
						modification: mod.modification.value,
						purchasePrice: mod.modificationValue
					};
				});
			}

			if (!!userInput.bikeForm.modificationsAccessories.accessories) {
				var accessories =
					userInput.bikeForm.modificationsAccessories
						.accessoriesTable;

				bike.qpyMotorcycleAccessories = accessories.map(function(
					acc,
					i
				) {
					return {
						accessory: acc.accessories.value,
						purchasePrice: acc.accessoryValue
					};
				});
			}
		}

		transformedRequest.motorcycles[0] = bike;

		return transformedRequest;
	}

	function updateKilometres(transformedRequest, userInput) {
		var bike = transformedRequest.motorcycles[0];

		if (
			!!userInput.bikeForm &&
			!!userInput.bikeForm.bikeDetails &&
			!!userInput.bikeForm.bikeDetails.kilometres
		) {
			bike.motorCycleKilometers =
				userInput.bikeForm.bikeDetails.kilometres;
			transformedRequest.motorcycles[0] = bike;
		}

		return transformedRequest;
	}

	function updateGarageType(transformedRequest, userInput) {
		var bike = transformedRequest.motorcycles[0];

		if (
			!!userInput.bikeForm &&
			!!userInput.bikeForm.bikeDetails &&
			!!userInput.bikeForm.bikeDetails.locationParked
		) {
			bike.garageType = userInput.bikeForm.bikeDetails.locationParked;
		}

		transformedRequest.motorcycles[0] = bike;

		return transformedRequest;
	}

	function updateFinancier(transformedRequest, userInput) {
		var bike = transformedRequest.motorcycles[0];

		if (
			!!userInput.bikeForm &&
			!!userInput.bikeForm.bikeDetails &&
			!!userInput.bikeForm.bikeDetails.isItFinanced
		) {
			bike.isFinanced = userInput.bikeForm.bikeDetails.isItFinanced;
			bike.financier =
				userInput.bikeForm.bikeDetails.financeWith.value ||
				userInput.bikeForm.bikeDetails.financeWith;
		} else {
			bike.isFinanced = false;
		}

		return transformedRequest;
	}

	function updateDamage(transformedRequest, userInput) {
		var bike = transformedRequest.motorcycles[0];

		if (
			!!userInput.bikeForm &&
			!!userInput.bikeForm.bikeDetails &&
			!!userInput.bikeForm.bikeDetails.existingDamage
		) {
			bike.damage = userInput.bikeForm.bikeDetails.existingDamage;
		}

		transformedRequest.motorcycles[0] = bike;

		return transformedRequest;
	}

	function updateUsage(transformedRequest, userInput) {
		var bike = transformedRequest.motorcycles[0];

		if (
			!!userInput.bikeForm &&
			!!userInput.bikeForm.bikeDetails &&
			!!userInput.bikeForm.bikeDetails.primaryBikeUse
		) {
			bike.motorCycleUsage =
				userInput.bikeForm.bikeDetails.primaryBikeUse;
		}

		transformedRequest.motorcycles[0] = bike;

		return transformedRequest;
	}

	function updateMotorcycleInfo(transformedRequest, userInput) {
		try{
			if (
				!!userInput.bikeForm &&
				!!userInput.bikeForm.aboutYourBike &&
				!!userInput.bikeForm.aboutYourBike.regoDetails
			) {
				transformedRequest.motorcycles[0].motorcycleInfo =
					userInput.bikeForm.aboutYourBike.regoDetails;
			} else if (!!userInput.bikeForm.motorcycleInfo) {
				transformedRequest.motorcycles[0].motorcycleInfo =
					userInput.bikeForm.motorcycleInfo;
			}
	
			if (!!userInput.bikeForm && 
				!!userInput.bikeForm.bikeDetails &&
				!!userInput.bikeForm.bikeDetails.businessActivityType) {
				transformedRequest.motorcycles[0].businessUsage =
					userInput.bikeForm.bikeDetails.businessActivityType;
			} else if (!!userInput.bikeForm.bikeDetails.commercialActivityType) {
				transformedRequest.motorcycles[0].commercialUsage =
					userInput.bikeForm.bikeDetails.commercialActivityType;
			}
		} catch(ex) {
			console.log(ex);
		}		

		return transformedRequest;
	}

	// endregion

	// region Step 2
	function updateRiders(transformedRequest, userInput) {
		transformedRequest.motorcycles[0].riders = [];
		if (!!userInput.bikeForm && !!userInput.bikeForm.rider) {
			if (!!userInput.bikeForm.rider.riders) {
				userInput.bikeForm.rider.riders.forEach(function(rider) {
					rider.person.contactType = 'person';
					rider.person.prefix = rider.person.title;
					rider.person.primaryAddress =
						transformedRequest.mainContactAddress !== null
							? transformedRequest.mainContactAddress
							: transformedRequest.policyAddress;

					//region yearsLicenced
					rider.yearsLicenced = rider.yearsHeld;
					switch (rider.yearsHeld) {
						case 'lessThan_1':
							rider.yearsLicenced = '0';
							break;
						case 'greaterThan_5':
							rider.yearsLicenced = '6';
							break;
						default:
							rider.yearsLicenced = rider.yearsHeld;
					}
					//endregion

					// region riderHistory
					if (
						rider.threeYears_accidentsClaims &&
						rider.threeYears_accidentsClaimsDetails.length < 1
					) {
						rider.threeYears_accidentsClaims = false;
					}

					if (
						rider.threeYears_restrictedSuspendedDisqualifiedCancelled &&
						rider
							.threeYears_restrictedSuspendedDisqualifiedCancelledDetails
							.length < 1
					) {
						rider.threeYears_restrictedSuspendedDisqualifiedCancelled = false;
					}

					if (
						rider.fiveYears_chargedOrConvicted &&
						rider.fiveYears_chargedOrConvictedDetails.length < 1
					) {
						rider.fiveYears_chargedOrConvicted = false;
					}
					rider.hasClaim = rider.threeYears_accidentsClaims;
					rider.hasConviction = rider.fiveYears_chargedOrConvicted;
					rider.hasLostLicence =
						rider.threeYears_restrictedSuspendedDisqualifiedCancelled;
					rider.riderHistory = [];

					if (rider.threeYears_accidentsClaims) {
						rider.riderHistory = rider.riderHistory.concat(
							rider.threeYears_accidentsClaimsDetails.slice()
						);
					}

					if (
						rider.threeYears_restrictedSuspendedDisqualifiedCancelled
					) {
						rider.riderHistory = rider.riderHistory.concat(
							rider.threeYears_restrictedSuspendedDisqualifiedCancelledDetails.slice()
						);
					}

					if (rider.fiveYears_chargedOrConvicted) {
						rider.riderHistory = rider.riderHistory.concat(
							rider.fiveYears_chargedOrConvictedDetails.slice()
						);
					}

					rider.riderHistory.forEach(function(rh) {
						rh.pattern = {
							publicID: '',
							description: '',
							code: '',
							filter1: ''
						};
						rh.pattern.publicID = rh.description.publicID;
						rh.pattern.description = rh.description.label;
						rh.pattern.code = rh.description.code;
						rh.pattern.filter1 = rh.description.filter1;

						rh.month = rh.month.value.toLowerCase();
						rh.year = rh.year.value;

						delete rh.description;
					});

					//endregion

					// region current insurer
					if (!!rider.previousInsurer) {
						rider.currentInsurer = rider.previousInsurer;

						delete rider.previousInsurer;
					}
					// endregion

					transformedRequest.motorcycles[0].riders.push({
						rider: rider
					});
					// endregion

					// region motorcycle club
					if (!!rider.isMemberOfClub && rider.motorcycleClub) {
						transformedRequest.motorcycles[0].isMemberOfClub =
							rider.isMemberOfClub;
						transformedRequest.motorcycles[0].motorcycleClub =
							rider.motorcycleClub;
					}
					//endregion
				});

				transformedRequest.motorcycles[0].riders[0].riderUsage = 'main';
			}

			// licensed to ride
			transformedRequest.motorcycles[0].riders[0].licensedToRide =
				userInput.bikeForm.rider.riders[0].licensedToRide;

			// is main rider
			transformedRequest.motorcycles[0].isTheMainRider =
				userInput.bikeForm.rider.riders[0].isTheMainRider;
		} else {
			transformedRequest.motorcycles[0].riders = [
				{
					riderUsage: 'main'
				}
			];
		}

		return transformedRequest;
	}

	function updatePolicyHolders(transformedRequest, userInput) {
		try {
			var bikeForm = userInput.bikeForm,
				mainPolicyHolder = bikeForm.mainPolicyHolder,
				companyDetails = bikeForm.aboutCompany,
				mainPolicyHolderContact = bikeForm.mainPolicyHolderContact,
				riders = transformedRequest.motorcycles[0].riders;

			// region mainPolicyHolder
			if (!!mainPolicyHolder) {
				var policyHolders = [];
				if (!!mainPolicyHolderContact) {
					// set primary address
					if (!!mainPolicyHolderContact.address) {
						mainPolicyHolderContact.primaryAddress =
							transformedRequest.mainContactAddress !== null
								? transformedRequest.mainContactAddress
								: transformedRequest.motorcycles[0].accountLocation;
						delete mainPolicyHolderContact.address;
					}
				}
				mainPolicyHolder.policyContact = mainPolicyHolderContact;

				if (mainPolicyHolder.isMainRiderMainPolicyHolder) {
					var rider = util.deepClone(
						transformedRequest.motorcycles[0].riders[0].rider
					);
					Object.extend(mainPolicyHolder, rider.person);
				}

				policyHolders.push(mainPolicyHolder);
				if (
					bikeForm.additionalPolicyHolders &&
					bikeForm.additionalPolicyHolders.policyHolders
				) {
					policyHolders = policyHolders.concat(
						bikeForm.additionalPolicyHolders.policyHolders
					);
				}

				policyHolders.forEach(function(policyHolder, index) {
					var contact = util.deepClone(policyHolder);
					if (!transformedRequest.policyHolders[index])
						transformedRequest.policyHolders[index] = {};

					var transformedContact =
						transformedRequest.policyHolders[index];
					if (!contact.contactType) contact.contactType = 'person';

					contact.prefix = contact.title;
					if (contact.policyContact) {
						Object.extend(contact, contact.policyContact);
						if (contact.primaryPhone == 'mobile')
							contact.cellPhone = contact.primaryPhoneNumber;
						else if (contact.primaryPhone == 'home')
							contact.homePhone = contact.primaryPhoneNumber;
						else if (contact.primaryPhone == 'work')
							contact.workPhone = contact.primaryPhoneNumber;

						delete contact.policyContact;
					}

					if (!contact.primaryAddress)
						contact.primaryAddress = util.clone(
							transformedRequest.policyHolders[0].contact
								.primaryAddress
						);

					// region driving history
					contact.hasClaim = contact.threeYears_accidentsClaims;
					contact.hasConviction = contact.fiveYears_chargedOrConvicted;
					contact.hasLostLicence =
						contact.threeYears_restrictedSuspendedDisqualifiedCancelled;

					if (
						contact.threeYears_accidentsClaims &&
						contact.threeYears_accidentsClaimsDetails.length < 1
					) {
						contact.threeYears_accidentsClaims = false;
					}

					if (
						contact.threeYears_restrictedSuspendedDisqualifiedCancelled &&
						contact
							.threeYears_restrictedSuspendedDisqualifiedCancelledDetails
							.length < 1
					) {
						contact.threeYears_restrictedSuspendedDisqualifiedCancelled = false;
					}

					if (
						contact.fiveYears_chargedOrConvicted &&
						contact.fiveYears_chargedOrConvictedDetails.length < 1
					) {
						contact.fiveYears_chargedOrConvicted = false;
					}

					contact.drivingHistory = [];

					if (contact.threeYears_accidentsClaims) {
						contact.drivingHistory = contact.drivingHistory.concat(
							contact.threeYears_accidentsClaimsDetails.slice()
						);
					}

					if (
						contact.threeYears_restrictedSuspendedDisqualifiedCancelled
					) {
						contact.drivingHistory = contact.drivingHistory.concat(
							contact.threeYears_restrictedSuspendedDisqualifiedCancelledDetails.slice()
						);
					}

					if (contact.fiveYears_chargedOrConvicted) {
						contact.drivingHistory = contact.drivingHistory.concat(
							contact.fiveYears_chargedOrConvictedDetails.slice()
						);
					}

					contact.drivingHistory.forEach(function(rh) {
						rh.riderPattern = {
							publicID: '',
							description: '',
							code: '',
							filter1: ''
						};
						rh.riderPattern.publicID = rh.description.publicID;
						rh.riderPattern.description = rh.description.label;
						rh.riderPattern.code = rh.description.code;
						rh.riderPattern.filter1 = rh.description.filter1;

						rh.riderMonth = rh.month.value.toLowerCase();
						rh.year = parseInt(rh.year.value);

						delete rh.description;
						delete rh.month;
						delete rh.pattern;
					});

					//endregion

					if (!transformedContact.contact)
						transformedContact.contact = {};
					transformedContact.contact.drivingHistory = [];
					Object.extend(transformedContact.contact, contact);
				});

				// region rider person
				if (!!riders[0] && !!riders[0].rider && !!riders[0].rider.person) {
					var riders = transformedRequest.motorcycles[0].riders;

					riders.forEach(function(rider, index) {
						//rider.rider.person.primaryAddress = transformedRequest.policyAddress;

						// first rider
						if (index === 0) {
							rider.rider.person.primaryPhone =
								mainPolicyHolder.policyContact.primaryPhone;

							switch (mainPolicyHolder.policyContact.primaryPhone) {
								case 'mobile':
									rider.rider.person.cellPhone =
										mainPolicyHolder.policyContact.primaryPhoneNumber;
									break;
								case 'home':
									rider.rider.person.homePhone =
										mainPolicyHolder.policyContact.primaryPhoneNumber;
									break;
								case 'work':
									rider.rider.person.workPhone =
										mainPolicyHolder.policyContact.primaryPhoneNumber;
									break;
								default:
									throw new Error(
										'unknown primaryPhone ' + primaryPhone
									);
							}

							rider.rider.person.passwordAnswer =
								mainPolicyHolder.policyContact.passwordAnswer;
							rider.rider.person.passwordQuestion =
								mainPolicyHolder.policyContact.passwordQuestion;
							if (
								rider.rider.person.passwordQuestion ===
								'customer_created_question'
							) {
								rider.rider.person.passwordQuestionStr =
									mainPolicyHolder.policyContact.passwordQuestionStr;
							}
						}
					});
				}
				// endregion
			} else if (!!companyDetails) {
				if (!!riders[0] && !!riders[0].rider && !!riders[0].rider.person) {
					var riders = transformedRequest.motorcycles[0].riders;

					riders.forEach(function(rider) {
						rider.rider.person.primaryAddress =
							transformedRequest.policyAddress;
					});
				}
			} else if (
				transformedRequest.motorcycles[0].riders[0] &&
				transformedRequest.motorcycles[0].riders[0].rider &&
				transformedRequest.motorcycles[0].riders[0].rider.person
			) {
				var rider = transformedRequest.motorcycles[0].riders[0].rider;
				var contact = transformedRequest.policyHolders[0].contact;
				Object.extend(contact, rider.person);
				contact.contactType = 'person';
				contact.hasClaim = rider.hasClaim;
				contact.hasConviction = rider.hasConviction;
			}
			// endregion

			transformedRequest.policyHolders.forEach(function(holder, index) {
				holder.mainHolder = index === 0;
			});

			// var rider = transformedRequest.motorcycles[0].riders[0].rider;
			// Object.extend(rider.person, transformedRequest.policyHolders[0]);
			// rider.person.emailAddress1 = userInput.mainPolicyHolderContact.emailAddress1;

			if (userInput.email) {
				if (
					userInput.bikeForm &&
					userInput.bikeForm.tellUsABitMore &&
					userInput.bikeForm.tellUsABitMore.yourEmailAddress
				) {
					transformedRequest.policyHolders[0].contact.emailAddress1 =
						userInput.bikeForm.tellUsABitMore.yourEmailAddress;
				} else if (
					userInput.bikeForm &&
					userInput.bikeForm.mainPolicyHolderContact &&
					userInput.bikeForm.mainPolicyHolderContact.emailAddress1
				) {
					transformedRequest.policyHolders[0].contact.emailAddress1 =
						userInput.bikeForm.mainPolicyHolderContact.emailAddress1;
				} else {
					transformedRequest.policyHolders[0].contact.emailAddress1 =
						userInput.email;
				}

				if (
					angular.isDefined(
						transformedRequest.motorcycles[0].riders[0].rider
					)
				) {
					if (
						userInput.bikeForm.tellUsABitMore &&
						userInput.bikeForm.tellUsABitMore.yourEmailAddress
					) {
						transformedRequest.motorcycles[0].riders[0].rider.person.emailAddress1 =
							userInput.bikeForm.tellUsABitMore.yourEmailAddress;
					} else if (
						userInput.bikeForm.mainPolicyHolderContact &&
						userInput.bikeForm.mainPolicyHolderContact.emailAddress1
					) {
						transformedRequest.motorcycles[0].riders[0].rider.person.emailAddress1 =
							userInput.bikeForm.mainPolicyHolderContact.emailAddress1;
					} else {
						transformedRequest.motorcycles[0].riders[0].rider.person.emailAddress1 =
							userInput.email;
					}
				}
			} else {
				if (
					userInput.bikeForm &&
					userInput.bikeForm.tellUsABitMore &&
					userInput.bikeForm.tellUsABitMore.yourEmailAddress
				) {
					if (transformedRequest.policyHolders[0].contact.emailAddress1) {
						//use the existing if available
					} else {
						transformedRequest.policyHolders[0].contact.emailAddress1 =
							userInput.bikeForm.tellUsABitMore.yourEmailAddress;
					}

					if (
						transformedRequest.motorcycles[0].riders[0].rider.person
							.emailAddress1
					) {
						//use the existing if available
					} else {
						transformedRequest.motorcycles[0].riders[0].rider.person.emailAddress1 =
							userInput.bikeForm.tellUsABitMore.yourEmailAddress;
					}
				}
			}

			if (
				userInput.bikeForm &&
				userInput.bikeForm.mainPolicyHolderContact &&
				userInput.bikeForm.mainPolicyHolderContact
					.personalContactDetailsMailingPreference
			) {
				transformedRequest.documentDeliveryMethod =
					userInput.bikeForm.mainPolicyHolderContact.personalContactDetailsMailingPreference;
				delete transformedRequest.policyHolders[0].contact
					.personalContactDetailsMailingPreference;
			}
		}
		catch (ex) {
			console.log(ex);
		}

		return transformedRequest;
	}

	function updateAccountLocation(transformedRequest, userInput) {
		try {
			var accountLocation = transformedRequest.motorcycles[0].accountLocation,
				bikeForm = userInput.bikeForm;

			accountLocation.addressType = 'residential';

			if (!!accountLocation) {
				if (
					!!bikeForm.getStarted &&
					!!bikeForm.getStarted.personOrCompany &&
					bikeForm.getStarted.personOrCompany === 'company'
				) {
					accountLocation.addressType = 'business';
				}
			}

			transformedRequest.motorcycles[0].accountLocation = accountLocation;
		}
		catch (ex) {
			console.log(ex);
		}

		return transformedRequest;
	}

	function updateAdditionalRiders(transformedRequest, userInput) {
		try{
			var fromRapidEstimate = !userInput.fromFullQuote,
				rider = userInput.bikeForm.rider,
				riders = rider ? rider.riders : null,
				/** required for when checking decline on step 1 */
				youngRider = null;

			if (!rider) return transformedRequest;

			if (!fromRapidEstimate) youngRider = findYoungestRider(rider.riders);

			transformedRequest.motorcycles[0].youngestRiderGender = fromRapidEstimate
				? rider.youngestRiderGender /** value from rapid estimate */
				: youngRider
				? youngRider.person.gender
				: null; /** value from full quote */

			transformedRequest.motorcycles[0].otherRiderHasProLicense = fromRapidEstimate
				? rider.provisionalLicence /** value from rapid estimate */
				: youngRider
				? youngRider.licenceType == 'provisional'
				: null; /** value from full path */

			transformedRequest.motorcycles[0].youngestRiderDOB = fromRapidEstimate
				? rider.youngestRiderDob
				: youngRider
				? youngRider.person.dateOfBirth
				: null;

			transformedRequest.motorcycles[0].otherRiderUsageTimes = fromRapidEstimate
				? rider.numberOfOtherRiders /* value from rapid estimate */
				: riders.length; /* value from full quote */
		}
		catch (ex) {
			console.log(ex);
		}
		return transformedRequest;
	}

	// endregion

	// region Step 3

	// endregion

	// region Step 4
	function updateRegoDetails(transformedRequest, userInput) {
		try {
			var tellUsYourRegoNumber = userInput.bikeForm.tellUsYourRegoNumber,
				regoNumber = null;

			if (tellUsYourRegoNumber && tellUsYourRegoNumber.regoNumber) {
				regoNumber = tellUsYourRegoNumber.regoNumber;
			}

			transformedRequest.motorcycles[0].registrationNumber = regoNumber;
		} catch (ex) {
			console.log(ex);
		}
		return transformedRequest;
	}

	// endregion

	function updateCompanyContactDetails(transformedRequest, userInput) {
		try {
			var policyHolder = util.deepClone(transformedRequest.policyHolders[0]);

			if (
				userInput.bikeForm &&
				userInput.bikeForm.getStarted &&
				userInput.bikeForm.getStarted.personOrCompany === 'company' &&
				!!userInput.bikeForm.companyContact &&
				!!userInput.bikeForm.aboutCompany
			) {
				transformedRequest.email = userInput.bikeForm.aboutCompany.email;

				policyHolder = {};
				policyHolder.contact = policyHolder.contact || {};
				policyHolder.contact.abn = userInput.bikeForm.aboutCompany.abn;
				policyHolder.contact.contactType = 'company';
				policyHolder.contact.emailAddress1 =
					userInput.bikeForm.aboutCompany.email;
				policyHolder.contact.passwordQuestion =
					userInput.bikeForm.companyContact.passwordQuestion;
				if (
					policyHolder.contact.passwordQuestion ===
					'customerCreatedQuestion'
				) {
					policyHolder.contact.passwordQuestionStr =
						userInput.bikeForm.companyContact.enterAQuestion;
				}
				policyHolder.contact.passwordAnswer =
					userInput.bikeForm.companyContact.passwordAnswer;
				policyHolder.contact.hasClaim = false;
				policyHolder.contact.hasConviction = false;
				policyHolder.contact.isJustInsured = false;
				policyHolder.contact.name = userInput.bikeForm.aboutCompany.name;
				policyHolder.contact.primaryAddress =
					userInput.bikeForm.aboutCompany.companyAddress;
				policyHolder.contact.primaryPhone = 'work';
				policyHolder.contact.workPhone =
					userInput.bikeForm.aboutCompany.officePhone;

				// region Authorised Person
				var authorisedPerson = {};
				authorisedPerson.contactType = 'person';
				var contact = userInput.bikeForm.companyContact;

				authorisedPerson.primaryAddress = contact.address;
				authorisedPerson.primaryPhone = contact.primaryPhone;
				switch (authorisedPerson.primaryPhone) {
					case 'mobile':
						authorisedPerson.cellPhone = contact.preferredNumber;
						break;
					case 'home':
						authorisedPerson.homePhone = contact.preferredNumber;
						break;
					case 'work':
						authorisedPerson.workPhone = contact.preferredNumber;
						break;
					default:
						throw new Error('unknown primaryPhone ' + primaryPhone);
				}
				authorisedPerson.dateOfBirth = contact.companyContactDateOfBirth;
				authorisedPerson.firstName = contact.companyContactFirstName;
				authorisedPerson.lastName = contact.companyContactLastName;
				authorisedPerson.gender = contact.companyContactGender;
				authorisedPerson.prefix = contact.companyContactTitle;
				authorisedPerson.emailAddress1 = contact.companyContactDetailsEmail;
				authorisedPerson.primaryAddress =
					contact.companyContactDetailsAddress;

				policyHolder.contact.authorisedPersons = [
					{
						person: authorisedPerson
					}
				];

				if (contact.postalOption === false) {
					transformedRequest.policyAddress =
						contact.companyContactDetailsPostalAddress;
				}
				// endregion
			} else {
				policyHolder.contact.contactType =
					userInput.bikeForm.getStarted.personOrCompany;
				policyHolder.contact.authorisedPersons = [
					{
						person: {
							contactType: 'person',
							primaryAddress: transformedRequest.policyAddress
						}
					}
				];
			}

			transformedRequest.policyHolders[0] = policyHolder;
			transformedRequest.policyHolders[0].mainHolder = true;

			if (
				userInput.bikeForm &&
				userInput.bikeForm.companyContact &&
				userInput.bikeForm.companyContact
					.companyContactDetailsMailingPreference
			) {
				transformedRequest.documentDeliveryMethod =
					userInput.bikeForm.companyContact.companyContactDetailsMailingPreference;
				delete transformedRequest.policyHolders[0].contact
					.companyContactDetailsMailingPreference;
			}
		}
		catch (ex) {
			console.log(ex);
		}
		return transformedRequest;
	}

	function updateMotorcycleInsuranceTypeAndAmount(
		transformedRequest,
		userInput
	) {
		try {
			var insuredExcessValue = userInput.bikeForm.insuredExcessValue;
			if (insuredExcessValue) {
				transformedRequest.motorcycles[0].sumInsuredType =
					insuredExcessValue.comprehensivePref;
				if (insuredExcessValue.comprehensivePref == 'agreed') {
					if (!!insuredExcessValue.agreedValue) {
						transformedRequest.motorcycles[0].sumInsuredAmount =
							insuredExcessValue.agreedValue;
					}
				}
				transformedRequest.motorcycles[0].excess.flexiExcessExcess = userInput.bikeForm.insuredExcessValue.flexiExcess;
			}
		} catch (ex) { 
			console.log(ex);
		}
		return transformedRequest;
	}

	//updates the email
	function updateEmail(transformedRequest, userInput) {
		try {
			if (
				userInput.bikeForm &&
				userInput.bikeForm.tellUsABitMore &&
				userInput.bikeForm.tellUsABitMore.yourEmailAddress
			) {
				transformedRequest.email =
					userInput.bikeForm.tellUsABitMore.yourEmailAddress;
			} else {
				//set email from maincontact if not available in tellUsABitMore
				if (
					userInput.bikeForm &&
					userInput.bikeForm.mainPolicyHolderContact &&
					userInput.bikeForm.mainPolicyHolderContact.emailAddress1
				) {
					transformedRequest.email =
						userInput.bikeForm.mainPolicyHolderContact.emailAddress1;
				}
			}

			// send the campaign code to GW
			if (
				userInput.bikeForm &&
				userInput.bikeForm.tellUsABitMore &&
				userInput.bikeForm.tellUsABitMore.promotionalCode
			) {
				transformedRequest.campaignCode =
					userInput.bikeForm.tellUsABitMore.promotionalCode;
			}
	    }
		catch (ex) {
			console.log(ex);
		}

		return transformedRequest;
	}

	function updatePolicyAddress(transformedRequest, userInput) {
		try {
			var postalAddress = storage.getItem('policy-address');

			if (
				angular.isDefined(userInput.bikeForm.mainPolicyHolderContact) ||
				angular.isDefined(userInput.bikeForm.companyContact)
			) {
				if (transformedRequest.postalAddress !== null) {
					transformedRequest.policyAddress =
						transformedRequest.postalAddress;
				} else {
					var isPostalOption = true;
					if(userInput.bikeForm.getStarted.personOrCompany == 'person'){
						isPostalOption = userInput.bikeForm.mainPolicyHolderContact.postalOption;
					} else {
						isPostalOption =
							userInput.bikeForm.companyContact.postalOption;
					}

					if (Object.keys(postalAddress).length > 0 && !isPostalOption) {
						transformedRequest.policyAddress = postalAddress;
					}
				}
			} else {
				if (Object.keys(postalAddress).length > 0) {
					transformedRequest.policyAddress = postalAddress;
				}
			}

			delete transformedRequest.postalAddress;
			delete transformedRequest.mainContactAddress;
		} catch (ex) {
			console.log(ex);
		}
		return transformedRequest;
	}

	function transform(userInput) {
		var transformedRequest = jsonMapper.transform(
			userInput,
			structureQuoteMapping
		);
		transformedRequest = updateIsMotorRegistered(transformedRequest);
		transformedRequest = updatePolicyHolderPrimaryAddress(
			transformedRequest
		);
		transformedRequest = updateModifications(transformedRequest, userInput);
		transformedRequest = updateKilometres(transformedRequest, userInput);
		transformedRequest = updateGarageType(transformedRequest, userInput);
		transformedRequest = updateFinancier(transformedRequest, userInput);
		transformedRequest = updateDamage(transformedRequest, userInput);
		transformedRequest = updateUsage(transformedRequest, userInput);
		transformedRequest = updateMotorcycleInfo(
			transformedRequest,
			userInput
		);
		transformedRequest = updateRiders(transformedRequest, userInput);
		transformedRequest = updatePolicyHolders(transformedRequest, userInput);
		transformedRequest = updateAccountLocation(
			transformedRequest,
			userInput
		);
		transformedRequest = updateAdditionalRiders(
			transformedRequest,
			userInput
		);
		transformedRequest = updateRegoDetails(transformedRequest, userInput);
		transformedRequest = updateCompanyContactDetails(
			transformedRequest,
			userInput
		);
		transformedRequest = updateMotorcycleInsuranceTypeAndAmount(
			transformedRequest,
			userInput
		);
		transformedRequest = updateEmail(transformedRequest, userInput);
		transformedRequest = updatePolicyAddress(transformedRequest, userInput);

		return transformedRequest;
	}

	function transposeMonth(monthName) {
		var months = {
			January: '01',
			February: '02',
			March: '03',
			April: '04',
			May: '05',
			June: '06',
			July: '07',
			August: '08',
			September: '09',
			October: '10',
			November: '11',
			December: '12'
		};

		return months[monthName];
	}

	return {
		transform: transform
	};
}
